import Banner from 'components/banner/Banner';

export default function PageWrapper({bg, menuName, title, comment, path, children}){
  return (
    <div className="">
      <Banner className="z-0" path={path} bg={bg} menuName={menuName} title={title} comment={comment}/>
      <div className='relative z-20'>
      {children}
      </div>
    </div>
  );
}